<template>
  <div>
    <v-flex sm10 offset-sm1 style="padding-top: 20px; min-height: 250px; overflow: hidden; height: 250px;">
      <div style="font-size: 17px; overflow: hidden; white-space: nowrap;"> Apply for permission to prohibit use of variety in country </div>
      <v-toolbar flat style="background-color: rgb(219, 219, 182); height: 57px;">
        <div style="float: left; width: 30%; padding-left: 10px;">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-select
              v-model.number="countryid"
              label="Country"
              single-line
              bottom
              item-value="id"
              item-text="name"
              :rules="countryRules"
              :items="countrylist"
              :readonly="readonly"
              v-if="showcountrydropdown"
              ></v-select>
          </v-form>
        </div>
        <div style="float: left; width: 35%; padding-bottom: 18px;" v-if="(applicationactivepage === 'approvedapplications') && (($store.getters.getUsertype === 'user') || ($store.getters.getUsertype === 'admin'))">
            <input id="fileinput" type="text" class="form-control" placeholder=" Choose file to upload..." :value="attachmentfilelist">
            <input type="file" style="display:none" multiple="multiple" id="attachments" @change="uploadFieldChange" ref="verificationfile">
        </div>
        <div style="float: left; padding-bottom: 12px;" v-if="(applicationactivepage === 'approvedapplications') && (($store.getters.getUsertype === 'user') || ($store.getters.getUsertype === 'admin'))">
          <button id="fileselectbtn" class="btn btn-default" type="button" @click="launchFilePicker">
            <span id="filepaperclip" class="glyph ion-paperclip" aria-hidden="true"></span>
          </button>
        </div>
        <div>
          <v-progress-linear
            id="fileuploadprogress"
            v-if="applicationactivepage === 'approvedapplications'"
            style="margin-top: -1px; margin-left: 15px;"
            :indeterminate="false"
            :query="false"
            v-model="percentCompleted"
            :active="progressbarvisable"
          ></v-progress-linear>
        </div>
      </v-toolbar>
      <v-card color="white"
              flat style="overflow-y: scroll;
              margin-right: 0px; height: 128px;
              border-left: 1px solid grey !important; border-right: 1px solid grey !important; border-bottom: 1px solid grey !important;">
        <v-data-table
          :items="verificationdetailslist"
          hide-actions
          item-key="countryname"
          expand
          ref="dTable"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td @click="props.expanded = !props.expanded" class="tablerow">{{ props.item.countryname }}</td>
            </tr>
          </template>
          <template slot="expand" slot-scope="props">
            <v-card flat>
            <div style="height: 35px;" v-if="props.item.attachments.length === 0">
              <label style="padding-left: 20px; padding-top: 10px;"> No files found for {{ props.item.countryname }}</label>
            </div>
            <v-list-tile
              two-line
              style="border-bottom: 1px solid #dbdbb6; list-style-type: none;"
              v-for="(attachment, index) in props.item.attachments" v-bind:key="index">
            <v-list-tile-content>
                <v-list-tile-title style="width: 250px;"><a v-bind:href="urlreadfile + '/' + props.item.countrycode + '/' + attachment.name.replace(/\+/g,'%2B')"> {{ attachment.name }}</a></v-list-tile-title>
              <v-list-tile-sub-title style="width: 250px; color:grey; font-size: 11px;"> Uploaded by: {{ attachment.uploadedby }}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-content>
                <v-list-tile-title style="padding-left: 10px; width: 100px;  font-size: 11px; color:grey" v-html="attachment.lastModifiedDate"></v-list-tile-title>
                <v-list-tile-sub-title style="padding-left: 10px; width: 100px; font-size: 11px; color: grey;" v-html="Number((attachment.size / 1024 ).toFixed(1)) + ' KB'"> </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-content>
              <v-list-tile-title @click="removeAttachment(attachment)">
                <button title="Delete" style="font-size: 20px;" class="ion-trash-a" v-if="showupload(attachment.user_id)"> </button>
              </v-list-tile-title>
            </v-list-tile-content>
            </v-list-tile>
            </v-card>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="450">
        <v-card>
          <v-card-title class="headline">Confirm</v-card-title>
          <v-card-text>Do you want to delete the file: <br><br> {{deletefile}} </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click.native="deleteattachmentfromserver()">Yes</v-btn>
            <v-btn color="green darken-1" flat @click.native="dialog = false">No</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>

import FilesService from '@/services/FilesService'

export default {
  watch: {
    applicationid: function () {
      this.refreshattachmentlist()
    }
  },
  computed: {
    countryRules () {
      return this.$store.getters.getCountryrules
    },
    applicationactivepage () {
      return this.$store.getters.getApplicationactivepage
    },
    applicationid () {
      if (this.applicationactivepage === 'submittedapplications') {
        return this.$store.getters.getSelectedapplicationidsubmitted
      }
      if (this.applicationactivepage === 'pendingapplications') {
        return this.$store.getters.getSelectedapplicationidpending
      }
      if (this.applicationactivepage === 'approvedapplications') {
        return this.$store.getters.getSelectedapplicationidapproved
      }
      if (this.applicationactivepage === 'rejectedapplications') {
        return this.$store.getters.getSelectedapplicationidrejected
      }
      if (this.applicationactivepage === 'verifiedapplications') {
        return this.$store.getters.getSelectedapplicationidverified
      }
      if (this.applicationactivepage === 'cancelledapplications') {
        return this.$store.getters.getSelectedapplicationidcancelled
      }
    },
    urlreadfile () {
      return this.$store.getters.getBaseurl + 'attachedfiles/read?application_id=' + this.applicationid +
        '&token=' + this.$store.getters.gettoken + '&filename='
    },
    readonly () {
      if (this.$store.getters.getUsertype === 'user') {
        return true
      }
    },
    showcountrydropdown () {
      if ((this.$store.getters.getUsertype === 'admin') && (this.applicationactivepage === 'approvedapplications')) {
        return true
      }
    },
    showform () {
      let tempvalue = true
      if (this.applicationactivepage === 'submittedapplications') {
        tempvalue = false
      }
      return tempvalue
    },
    countrylist () {
      return this.$store.getters.getCountries
    }
  },
  data () {
    return {
      testvalue: 0,
      valid: true,
      data: new FormData(),
      countryid: null,
      verificationdetailslist: [],
      verified: true,
      anchorref: null,
      dialog: false,
      verificationfile: '',
      confirmdeletefile: false,
      // File selected to be deleted
      deletefile: '',
      deletefilefolder: '',
      // Array of files selected for upload
      attachments: [],
      // List of files to upload in string format
      attachmentfilelist: '',
      percentCompleted: 0,
      progressbarvisable: false,

      // Config for axios header
      config: {
        headers: { 'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + this.$store.state.auth.userdata.accesstoken },
        onUploadProgress: function (progressEvent) {
          this.percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          console.log('completed' + this.percentCompleted)
        }.bind(this)
      }
    }
  },
  methods: {
    showupload (userId) {
      let defaultvalue = false
      if (this.applicationactivepage === 'approvedapplications') {
        if (this.$store.getters.getUsertype === 'admin') {
          defaultvalue = true
        }
        if ((this.$store.getters.getUsertype === 'user') && (this.$store.getters.getUserid === userId)) {
          defaultvalue = true
        }
      }
      return defaultvalue
    },
    refreshattachmentlist () {
      if (this.applicationactivepage === 'submittedapplications') {
        try {
          this.verificationdetailslist = this.$store.getters.getApplicationslistsubmitted[this.applicationid].verificationfiles
        } catch (error) {
          this.verificationdetailslist = []
        }
      }
      if (this.applicationactivepage === 'pendingapplications') {
        try {
          this.verificationdetailslist = this.$store.getters.getApplicationslistpending[this.applicationid].verificationfiles
        } catch (error) {
          this.verificationdetailslist = []
        }
      }
      if (this.applicationactivepage === 'approvedapplications') {
        try {
          this.verificationdetailslist = this.$store.getters.getApplicationslistapproved[this.applicationid].verificationfiles
        } catch (error) {
          this.verificationdetailslist = []
        }
      }
      if (this.applicationactivepage === 'rejectedapplications') {
        try {
          this.verificationdetailslist = this.$store.getters.getApplicationslistrejected[this.applicationid].verificationfiles
        } catch (error) {
          this.verificationdetailslist = []
        }
      }
      if (this.applicationactivepage === 'verifiedapplications') {
        try {
          this.verificationdetailslist = this.$store.getters.getApplicationslistverified[this.applicationid].verificationfiles
        } catch (error) {
          this.verificationdetailslist = []
        }
      }
      if (this.applicationactivepage === 'cancelledapplications') {
        try {
          this.verificationdetailslist = this.$store.getters.getApplicationslistcancelled[this.applicationid].verificationfiles
        } catch (error) {
          this.verificationdetailslist = []
        }
      }
      console.log('verificationdetailslist: ')
      console.log(this.verificationdetailslist)
      this.expandtable(this.verificationdetailslist)
    },
    // Launch the file picket for uploading attachments
    launchFilePicker () {
      if (this.applicationid) {
        this.$refs.verificationfile.click()
      } else {
        alert('Select first one of the pending application')
      }
    },
    // Validate if file were selected for upload attachments
    validate () {
      if (!this.attachments.length) {
        this.$toastr.warning('Please add files', 'Warning')
        return false
      }
      return true
    },
    // Prepare the correct format for uploading files
    prepareFields () {
      for (var i = this.attachments.length - 1; i >= 0; i--) {
        this.data.append('attachments[]', this.attachments[i])
        this.attachmentfilelist = this.attachmentfilelist + '/' + this.attachments[i].name
      }
      this.data.append('category_id', '1')
      this.data.append('application_id', this.applicationid)
      this.data.append('country_id', this.countryid)
    },
    // Popup dialog to confirm delete attachements
    removeAttachment (attachment) {
      this.deletefile = attachment.name
      this.deletefilefolder = attachment.folder
      console.log('remove attachment dialog' + attachment.name)
      this.dialog = true
    },
    // This function will be called every time you add a file
    uploadFieldChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      for (var i = files.length - 1; i >= 0; i--) {
        console.log(files[i])
        this.attachments.push(files[i])
      }
      this.submit()
    },
    // Start uploading the attachments
    submit () {
      this.prepareFields()
      if (!this.$refs.form.validate()) {
        this.resetData()
        return false
      }
      this.sendfile()
    },
    // Start the upload attachements progress bar
    loading () {
      console.log('delay')
      this.progressbarvisable = false
    },
    // Logout and go to the front-page when repy code is 401 for call to the server
    logout () {
      this.$store.dispatch('logout')
      this.$toastr('error', 'Your session has expired, please login again!', 'Logged out')
      this.$router.push({
        name: 'frontpage'
      })
    },
    // Send attachment call to the FileService
    async sendfile () {
      try {
        this.progressbarvisable = true
        const response = await FilesService.uploadreviewfile(this.data, this.config)
        if (response.status) {
          this.$toastr('success', 'Documents uploaded!', 'Success')
          this.resetData()
          this.$store.dispatch('fetchApplicationslistapproved').then(response => {
            this.verificationdetailslist = this.$store.getters.getApplicationslistapproved[this.applicationid].verificationfiles
          }).catch(error => {
            console.log(error)
            this.$toastr('Errors', 'Could not get the files from the server', 'Error')
          })
          setTimeout(this.loading, 700)
        } else {
          this.$toastr('error', 'Something went wrong!', 'Error')
          setTimeout(this.loading, 700)
        }
        setTimeout(this.loading, 700)
      } catch (e) {
        console.log('send file error:' + e)
        if (e.response.status === 401) {
          this.$toastr('error', 'Your session has expired, please login again!', 'Logged out')
          this.logout()
        }
        setTimeout(this.loading, 700)
      }
    },
    // Delete attachment call to the FileService
    async deleteattachmentfromserver () {
      this.dialog = false
      try {
        const response = await FilesService.deletefile({
          headers: { 'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + this.$store.state.auth.userdata.accesstoken },
          params: {'filename': this.deletefilefolder + this.deletefile, 'application_id': this.applicationid, 'Authorization': 'Bearer ' + this.$store.state.auth.userdata.accesstoken}
        })
        if (response.status) {
          this.$toastr('success', 'File deleted', 'Success')
          this.resetData()
          this.$store.dispatch('fetchApplicationslistapproved').then(response => {
            this.verificationdetailslist = this.$store.getters.getApplicationslistapproved[this.applicationid].verificationfiles
          }).catch(error => {
            console.log(error)
            this.$toastr('Errors', 'Could not get the files from the server', 'Error')
          })
        } else {
          this.$toastr('error', 'Something went wrong with the delete!', 'Error')
        }
      } catch (e) {
        console.log('delete file error:' + e)
      }
    },
    // We want to clear the FormData object on every upload so we can re-calculate new files again.
    resetData () {
      this.data = new FormData() // Reset it completely
      this.attachments = []
      this.attachmentfilelist = ''
    },
    expandtable () {
      for (let i = 0; i < this.verificationdetailslist.length; i += 1) {
        const item = this.verificationdetailslist[i]
        this.$set(this.$refs.dTable.expanded, item.countryname, true)
      }
    },
    resetformvalues () {
      if (this.$store.getters.getUsercountryid) {
        this.countryid = this.$store.getters.getUsercountryid
      }
    }
  },
  created () {
    this.resetformvalues()
  },
  mounted () {
    this.refreshattachmentlist()
  }
}
</script>

<style>
.tablerow {
  background-color: #f9fafc;
}
</style>

<style scoped>
@import '@../../../assets/css/ionicons.min.css';

#fileuploadgroup {
  width: 40% !important;
}
#fileuploadprogress {
  width: 100% !important;
}
#fileinput {
  width: 100%;
  height: 25px;
  border: 1px solid black;
  border-top-left-radius: .3rem;
  border-bottom-left-radius: .3rem;
  background-color: lightgrey;
  font-size: 12px;
  margin-top: 8px;
  margin-left: 20px;
  overflow: hidden;
}
#fileselectbtn {
  min-width: 35px;
  height:25px;
  padding: 0 0 0 0;
  border: 1px solid black;
  border-top-right-radius: .3rem;
  border-bottom-right-radius: .3rem;
  background-color: white;
  margin-left: -2px;
  margin-top: 8px;
}
#filepaperclip {
  font-size:24px;
  transform: rotate(45deg);
  vertical-align: top !important;
  display: flex;
  background-color: white;
}
.list__tile__title{
  font-size: 13px;
}
.list__tile__sub-title{
  font-size: 13px;
}
.list__tile{
  padding-right: 1px !important;
  height: 20px !important;
}
.column.active{
  background-color: red !important;
}
.hidden-sm-and-down{
  padding-top: 0px !important;
}
table.table tbody td, table.table tbody th {
    height: 28px;
}
.input-group{
  padding-top: 0px !important;
  margin-top: 6px;
  margin-bottom: -6px !important;
}
</style>

<style>
.list__tile{
  height: 38px;
}
.input-group label{
  font-size: 13px !important;
}
.list__tile__title{
  font-size: 13px !important;
}
.toolbar{
  border-top: 1px black solid;
  border-left: 1px black solid;
  border-right: 1px black solid;
}
.input-group label{
  top: 0px !important;
}
.input-group__selections__comma{
  font-size: 13px !important;
}
table.table thead tr {
  height: 0px !important;
}
.input-group__input{
  background-color: white;
  border-top-right-radius: .3rem;
  border-bottom-right-radius: .3rem;
  border-top-left-radius: .3rem;
  border-bottom-left-radius: .3rem;
}
.input-group__selections{
  padding-left: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/applications/Applicationverificationfiles.vue